import type { ReactNode } from "react";

interface SectionHeadProps {
  title: ReactNode;
  sub?: ReactNode;
  align?: "left" | "center";
}

export default function SectionHead({
  title,
  sub,
  align = "left",
}: SectionHeadProps): JSX.Element {
  return (
    <div
      className={align === "center" ? "text-center max-w-[760px] mx-auto" : "text-left max-w-[760px]"}
    >
      <h2 className="text-section">{title}</h2>
      {sub ? (
        <p
          className={
            align === "center"
              ? "text-fg-muted mt-4 text-[17px] max-w-[620px] mx-auto"
              : "text-fg-muted mt-4 text-[17px] max-w-[620px]"
          }
        >
          {sub}
        </p>
      ) : null}
    </div>
  );
}
